import { get } from "@src/appV2/api/api";
import { environmentConfig } from "@src/appV2/environment/index";
import { z } from "zod";

export enum SolveUnpaidBreaksRolloutStage {
  OFF = "off",
  CBH_PAYS_FOR_WORKED_BREAKS = "cbh-pays-for-worked-breaks",
  FACILITIES_PAY_FOR_WORKED_BREAKS = "facilities-pay-for-worked-breaks",
}

export const solveUnpaidBreaksStageWithTargeting = z.object({
  stage: z.nativeEnum(SolveUnpaidBreaksRolloutStage),
  minimalStoreVersion: z.string(),
  minimalOtaVersion: z.string(),
});

export type SolveUnpaidBreaksRolloutStageWithTargeting = z.infer<
  typeof solveUnpaidBreaksStageWithTargeting
>;

export const solveWorkedUnpaidBreaksStageResponseSchema = z.object({
  solveUnpaidBreaksStageWithTargeting,
});

export type SolveWorkedUnpaidBreaksStageResponse = z.infer<
  typeof solveWorkedUnpaidBreaksStageResponseSchema
>;

export async function getSolveUnpaidBreaksStage(
  facilityId: string
): Promise<SolveWorkedUnpaidBreaksStageResponse> {
  const response = await get({
    url: `${environmentConfig.REACT_APP_BASE_API_URL}/facilityprofile/${facilityId}/solveWorkedUnpaidBreaksStageWithTargeting`,
    responseSchema: solveWorkedUnpaidBreaksStageResponseSchema,
  });
  return response.data;
}
